export const QUERY_KEYS = {
  // Identity
  IDENTITY_ME: 'identity/me',
  IDENTITY_PROFILE: 'identity/profile',
  IDENTITY_KYC_INFO: 'identity/kyc-info',
  IDENTITY_KYC_SDK_ACCESS_TOKEN: 'identity/kyc-sdk-access-token',
  IDENTITY_FAVORITE_USERS: 'identity/favorite-users',
  IDENTITY_BLOCKED_USERS_LIST: 'identity/blocked-users-list',
  IDENTITY_DINARI_KYC_STATUS: 'identity/dinari-kyc-status',

  // Wallet
  WALLET: 'wallet',
  WALLET_CURRENCIES: 'wallet/currencies',
  CRYPTO_ADDRESSES: 'wallet/crypto-addresses',
  WITHDRAW_CRYPTO_ADDRESSES: 'wallet/withdraw-crypto-addresses',
  CURRENCY_IN_BLOCKCHAIN: 'wallet/currency-in-blockchain',
  KEM_CARD_ENCRYPTED: 'wallet/kem-card-encrypted',
  CARD_PIN: 'wallet/card-pin',
  INTERLACE_WIDGET_TOKEN: 'wallet/interlace-widget-token',
  UNIGOX_OFFRAMP_PAYMENT_RAILS: 'wallet/unigox-offramp-payment-rails',
  UNIGOX_OFFRAMP_INSTITUTIONS: 'wallet/unigox-offramp-institutions',
  UNIGOX_OFFRAMP_PAYMENT_DETAILS: 'wallet/unigox-offramp-payment-details',

  // RAIN Provider
  RAIN_SESSION_ID: 'rain/session-id',

  // Card Issue State
  IDENTITY_CARD_STATE: 'identity/card-state',

  // Savings
  SAVING_GOALS: 'savingGoals',
  SAVINGS_GOAL: 'savings/goal',
  SAVINGS_GOAL_HISTORY: 'savings/goal-history',
  SAVINGS_GOAL_TRANSFER_DETAILS: 'savings/goal-transfer-details',

  // Features
  FEATURES_SETTINGS: 'features/settings',

  // Health
  API_HEALTH: 'api/health',

  // Blockchains
  CATALOGS_BLOCKCHAINS: 'catalogs/blockchains',
  CATALOGS_MESSAGING_METHODS: 'catalogs/messaging-methods',
  CATALOGS_COUNTRIES: 'catalogs/countries',
  CATALOGS_CURRENCIES: 'catalogs/currencies',

  // History
  CRYPTO_PRICE_HISTORY: 'history/crypto-price',

  // Requests
  PAYMENT_REQUESTS_HISTORY: 'payment-requests/history',
  PENDING_REQUESTS_COUNT: 'payment-requests/count',
  PAYMENT_LINK_INFO: 'payment-link/info',

  // Transfer
  TRANSACTIONS: 'transactions',
  CASHBACK_INFO: 'transfer/cashback-info',
  OFFRAMP_PRICE_LIMITS: 'transfer/offramp-price-limits',
  OFFRAMP_PRICE_ESTIMATE: 'transfer/offramp-price-estimate',
  OFFRAMP_PRICE_QUOTES: 'transfer/offramp-price-quotes',

  // Shares
  SHARES_STOCKS: 'shares/stocks',
  SHARES_STOCK_CATEGORIES: 'shares/stock-categories',
  SHARES_MARKET_INFO: 'shares/market-info',
  SHARES_STOCK_DETAILS: 'shares/stock-details',
  SHARES_STOCK_HISTORICAL_PRICES: 'shares/stock-historical-prices',
  SHARES_MY_STOCKS: 'shares/my-stocks',
  SHARES_STOCKS_COUNT: 'shares/stocks-count',
  SHARES_PORTFOLIO_INFO: 'shares/portfolio-info',
  SHARES_PORTFOLIO_POSITION: 'shares/portfolio-position',
  SHARES_PRICE_PER_UNIT: 'shares/price-per-unit',
  SHARES_QUOTES: 'shares/quotes',
} as const
